const cardBlacklist = {
  header: {
    btnCreate: 'הוסף',
  },

  forms: {
    header: {
      create: {
        title: 'הוסף',
      },
      update: {
        title: 'עדכן',
      },
    },
    create: {
      success: 'כרטיס ברשימה שחורה נוסף!',
      failure: 'לא ניתן ליצור כרטיס ברשימה שחורה',
      header: 'צור פריט ברשימת שחורה של כרטיסים',
      footer: {
        submit: 'שמור',
      },
    },
    update: {
      footer: {
        submit: 'עדכן',
      },
    },
    sections: {
      details: {
        header: 'פרטים',
        fields: {
          number: 'מספר כרטיס',
        },
      },
    },
  },
  table: {
    headers: {
      number: 'מספר כרטיס',
      site: 'אתר',
    },
    actions: {
      delete: {
        modal: {
          header: 'מחק כרטיסים ברשימה שחורה',
          body: 'אתה עומד למחוק {{num}} כרטיסים ברשימה שחורה.',
        },
        success: 'הכרטיסים ברשימה שחורה נמחקו בהצלחה',
      },
      create: 'הוסף',
    },
    floatingActions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    
  },
};

export default cardBlacklist;
